import axios from 'axios';
import authHeader from "@/service/auth-header";

class FilterService {

    async getUserFilters(userId) {
        return await axios.get(`/api/applications/si/filter/${userId}`,{ headers: authHeader() })
    }

    async getUserActiveFilters(userId) {
        return await axios.get(`/api/applications/si/filter/active/${userId}`,{ headers: authHeader() })
    }

    async searchFilters(userId, searchCriteria) {
        console.log("[FilterService][searchFilters] userId = ", userId);
        console.log("[FilterService][searchFilters] searchCriteria = ", searchCriteria);
        return await axios.get(`/api/applications/si/filter/search/${userId}/${searchCriteria}`,{ headers: authHeader() })
    }

    async getFilter(id) {
        return await axios.get(`/api/applications/si/filter/specific/${id}`,{ headers: authHeader() })
    }

    async createFilter(userId, data) {
        return await axios.post(`/api/applications/si/filter/${userId}`, data,{ headers: authHeader() });
    }

    async createFilterWithType(userId, type, data) {
        return await axios.post(`/api/applications/si/filter/${userId}/${type}`, data,{ headers: authHeader() });
    }

    async updateFilter(id, data) {
        return await axios.put(`/api/applications/si/filter/${id}`, data,{ headers: authHeader() });
    }

    async deleteFilter(id) {
        return await axios.delete(`/api/applications/si/filter/${id}`,{ headers: authHeader() })
    }

    async getStockDataForFilter(id) {
        return await axios.get(`/api/applications/si/filter/stockdata/${id}`,{ headers: authHeader() })
    }


}

export default new FilterService();
